import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EPermissions } from '@enums/permissions.enum';
import { ContentContainerComponent } from '@shared/components/content-container/content-container.component';
import { ICreateEntityButtonConfiguration } from '@shared/components/create-entity-button/create-entity-button.interface';
import { AddPlatformDialogComponent } from './creator-details/add-platform-dialog/add-platform-dialog.component';
import { CreatorsBannerComponent } from './creators-banner/creators-banner.component';
import { CreatorsDatatableComponent } from './creators-datatable/creators-datatable.component';
import { CreatorsStore } from './creators.store';

@Component({
  imports: [CreatorsDatatableComponent, CreatorsBannerComponent, ContentContainerComponent],
  providers: [CreatorsStore],
  selector: 'app-creators',
  templateUrl: './creators.component.html',
})
export class CreatorsComponent {
  public readonly addButtonConfiguration: ICreateEntityButtonConfiguration = {
    labelKey: 'pages.creators.datatable.newCreator',
    onClick: this.onCreateClick.bind(this),
    permissions: [EPermissions.creatorCreate],
  };

  public readonly store = inject(CreatorsStore);
  private readonly dialog = inject(MatDialog);

  constructor() {
    this.store.fetchCreators({
      joins: ['campaign_creators', 'channels'],
      limit: 1000,
      sort: [{ active: 'created_at', direction: 'desc' }],
    });
  }

  private onCreateClick(): void {
    this.dialog.open(AddPlatformDialogComponent, {
      autoFocus: true,
      data: {
        creator: null,
        redirectToCreatorDetails: true,
      },
    });
  }
}
